export default "__VITE_PUBLIC_ASSET__a5a7cf62__"